import Service from '../Service'
import {http} from '../config'

export default class CompromissoService extends Service{

    constructor(){
        super('compromisso');
    }

    Baixar(modelo){
        return http.put(`${this._nomeControle}/${modelo.id}/baixar`, modelo);
    }

    Cancelar(id){
        return http.put(`${this._nomeControle}/${id}/cancelar`);
    }

    Reabrir(id){
        return http.put(`${this._nomeControle}/${id}/reabrir`);
    }

    GetFiltro(parametros, filter){
        if(parametros === '?'){
            parametros = '';
        }

        if (filter) {
            let paramTemp = '';

            if (filter.fornecedorId){
                paramTemp += `fornecedorId eq ${filter.fornecedorId}`;
            }

            if (filter.projetoId){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `projetoId eq ${filter.projetoId}`;
            }

            if (filter.situacao){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `situacao eq '${filter.situacao}'`;
            }

            if (filter.vencimentoInicial){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `dataVencimento ge ${filter.vencimentoInicial}`;
            }
            
            if (filter.vencimentoFinal){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `dataVencimento le ${filter.vencimentoFinal}`;
            }

            if (filter.pagamentoInicial){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `dataPagamento ge ${filter.pagamentoInicial}`;
            }
            
            if (filter.pagamentoFinal){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `dataPagamento le ${filter.pagamentoFinal}`;
            }

            if (filter.emissaoInicial){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `dataEmissao ge ${filter.emissaoInicial}`;
            }
            
            if (filter.emissaoFinal){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `dataEmissao le ${filter.emissaoFinal}`;
            }

            if (filter.competenciaInicial){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `dataCompetencia ge ${filter.competenciaInicial}`;
            }
            
            if (filter.competenciaFinal){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `dataCompetencia le ${filter.competenciaFinal}`;
            }

            if (filter.numeroDocumento){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `numeroDocumento eq '${filter.numeroDocumento}'`;
            }

            if (filter.codigoInicio){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `id ge ${filter.codigoInicio}`;
            }

            if (filter.codigoFim){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `id le ${filter.codigoFim}`;
            }

            if (paramTemp) {
                if(parametros){
                    parametros += '&';
                }
                else{
                    parametros += '?';
                }
                parametros += `$filter=${paramTemp}`;
            }
        }

        return parametros;
    }

    ListarComFiltro(page, pageSize, sortBy, desc, search, columns, filter, include){
        let parametros = this.GetParamentroPaginacaoOrdenacao(page, pageSize, sortBy, desc, search, columns);
        parametros = this.GetFiltro(parametros, filter);
        return http.get(`${this._nomeControle}${parametros}`, this.GetHeader(include));
    }

    TotalizadoresComFiltro(search, columns, filter, include){
        let parametros = this.GetParamentroPaginacaoOrdenacao(null, null, null, [], search, columns);
        parametros = this.GetFiltro(parametros, filter);

        if(parametros === '?'){
            parametros = '';
        }

        return http.get(`${this._nomeControle}/Totalizadores${parametros}`, this.GetHeader(include));
    }

    EnviarDocumento(compromissoId, nome, arquivo){
        let bodyFormData = new FormData();
        bodyFormData.append('arquivo', new Blob([arquivo], { type: 'application/pdf' }));

        return http.post(`${this.getNomeControle()}/${compromissoId}/documento`, bodyFormData, {
            headers: {'Content-Type': 'multipart/form-data' },
            params: {
                nome: nome
            }
        });
    }

    DeletarDocumento(compromissoId, nome){
        return http.delete(`${this.getNomeControle()}/${compromissoId}/documento`, {
            params: {
                nome: nome
            }
        });
    }

    DownloadDocumento(compromissoId, nome){
        return http.get(`${this.getNomeControle()}/${compromissoId}/documento`, {
            responseType: 'blob',
            params: {
                nome: nome
            }
        }).then(res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nome);
            document.body.appendChild(link);
            link.click();
        });
    }

    ObterCompromissos(projetoId, dataInicial, dataFinal, emissaoInicial, emissaoFinal, competenciaInicial, competenciaFinal){
        return http.get(`${this._nomeControle}/ObterCompromisso`, {
            params: {
                projetoId: projetoId,
                dataInicial: dataInicial,
                dataFinal: dataFinal,
                emissaoInicial,
                emissaoFinal,
                competenciaInicial,
                competenciaFinal
            }
        });
    }

    Relatorio(fornecedorId, projetoId, vencimentoInicial, vencimentoFinal, pagamentoInicial, pagamentoFinal, emissaoInicial, emissaoFinal, competenciaInicial, competenciaFinal, 
        numeroDocumento, stuacaoId, codigoInicial, codigoFinal){
        return http.get(`${this._nomeControle}/Relatorio`,{
            params:{
                fornecedorId,
                projetoId,
                vencimentoInicial,
                vencimentoFinal,
                pagamentoInicial,
                pagamentoFinal,
                emissaoInicial,
                emissaoFinal,
                competenciaInicial,
                competenciaFinal,
                numeroDocumento,
                stuacaoId,
                codigoInicial,
                codigoFinal
            }
        });
    }

  }
